import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ChatProvider } from './components/ChatContext';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme'; // import your theme

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ChatProvider>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </ChatProvider>
  </React.StrictMode>
);

reportWebVitals();
